import { mapGetters } from 'vuex';
import commentForm from '@/components/helpers/commentForm/index.vue';

import Api from '@/utils/api';

export default {
  components: {
    commentForm,
  },
  props: {
    error: {
      type: Object,
      default: () => {},
      required: true,
    },
    comment: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  data () {
    return {
      loading: false,
      refreshKey: 0,
      commentEdit: '',
      isEdit: false,
    };
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
    isAuthor () {
      return this.user.UserId === this.comment.AuthorId;
    },
  },
  methods: {

    /**
         * Method for update comment
         */
    updateComment () {
      const params = {
        ID: this.comment.CommentId,
        UserId: this.user.UserId,
        ErrorItemID: this.error.ID,
        CommentText: this.commentEdit,
        CreationDateTime: this.$filters.currentDate(),
      };

      Api.reports
        .updateErrorItemComment(params)
        .then((response) => {
          if (response.data.Status) {
            this.$root.$emit('notification', {
              message: 'Message has updated!',
              type: 'info',
              show: true,
            });

            this.$emit('refresh');
          } else {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
    },

    /**
         * Show dialog window
         *
         * @param {Number} id
         */
    handlerRemoveComment () {
      this.$modal.show('dialog', {
        title: 'Warning!',
        text: 'Are you sure delete this overview groups?',
        buttons: [{
          title: 'Yes',
          handler: () => {
            this.removeComment();

            this.$modal.hide('dialog');
          },
        }, {
          title: 'No',
        }],
      });
    },

    /**
         * Method for remove comment
         */
    removeComment () {
      const params = {
        ErrorItemID: this.error.ID,
        ErrorCommentID: this.comment.CommentId,
      };

      Api.reports
        .removeErrorItemComment(params)
        .then((response) => {
          if (response.data.Status) {
            this.$root.$emit('notification', {
              message: 'Message has deleted!',
              type: 'info',
              show: true,
            });

            this.$emit('removeComment');
          } else {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
    },
    /**
         * Method for change comment
         *
         * @param {String} newComment
         */
    changeCommentInput (newComment) {
      this.commentEdit = newComment;
    },

    /**
         * Method edit comment
         */
    edit () {
      this.isEdit = !this.isEdit;
      this.commentEdit = this.comment.CommentText;
    },
  },
};
